import {createTheme} from '@mui/material/styles';

export const defaultMuiTheme = createTheme();
